<template>
  <div class="info_box">
    <div class="m-b-30" v-for="(item,index) in showObject" :key="index">
      <el-descriptions title="" direction="vertical" :column="3" border v-if="index === 0">
        <el-descriptions-item label="订单编号">
          {{item.orderNumber}}
        </el-descriptions-item>
        <el-descriptions-item label="订单状态">
          {{orderStatusList[item.status]}}
        </el-descriptions-item>
        <el-descriptions-item label="退款状态" v-if="item.refundStatus">
          {{refundStatusList[item.refundStatus]}}
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">
          {{payList[item.payType] || '其他'}}
        </el-descriptions-item>
        <el-descriptions-item label="订单时间">
          {{item.createTime}}
        </el-descriptions-item>
        <el-descriptions-item label="发货时间">
          {{item.dvyTime}}
        </el-descriptions-item>
        <el-descriptions-item label="完成时间">
          {{item.finallyTime}}
        </el-descriptions-item>
        <el-descriptions-item label="订单备注" :span="3">
          {{item.remarks}}
        </el-descriptions-item>

      </el-descriptions>

    </div>
      <tableTotal :index-show="configTable.indexShow" :config-data="configTable.configData"
                  :table-data="showObject" :loading="configTable.loading"
                  :height="configTable.height">
      </tableTotal>

  </div>
</template>

<script>
  import tableTotal from "@/components/TableTotal/TableTotal";

  export default {
    name: "seeGoodsInfo",
    props: ['goodsInfo'],
    data() {
      return {
        showObject: [],
        orderStatusList: {
          0: '全部状态',
          1: '待付款',
          2: '待发货',
          3: '待收货',
          4: '待评价',
          5: '已完成',
          6: '已取消',
          7:'交易中',//线下
							 8:'交易确认中',//线下
        },
        // 退款状态：0:默认,1:在处理,2:处理完成
        refundStatusList: {
          0: '默认',
          1: '在处理',
          2: '处理完成',
        },
        //支付方式 ： 1 ：微信支付 ；2： 支付宝；3：数字人民币；4：银联支付
        payList: {
          1: '微信支付',
          2: '支付宝',
          3: '数字人民币',
          4: '银联支付',
        },
        // 配置表格
        configTable: {
          height: 400,
          loading: false,
          indexShow: false,
          configData: [
            {
              value: 'goodsThumbnail',
              label: '指姆图',
              width: 150,
              align: 'left',
              type: 'img'
            }, {
              value: 'goodsName',
              label: '产品名称',
              align: 'left',
              isCopy: true,
            },
            {
              value: 'goodsPrice',
              label: '商品价格',
              align: 'center',
              type: 'price',
              style: {
                css: 'font-weight: 700;color:#e1251b;',
                currency: '￥',
              }
            },
            {
              value: 'goodsDescribe',
              label: '商品描述',
              align: 'left',
              showOverflow: true,
            },
            {
              value: 'goodsCategory',
              label: '商品类型',
              align: 'left',
              objList: {
                1: '影像数据',
                2: '数据产品',
                3: '软件产品',
                4: '其他产品'
              }
            },
            // {
            //   value: 'goodsPriceType',
            //   label: '商品价格类型',
            //   align: 'left',
            //   objList: { // 商品价格类型：1：商品金额：2：面议；3：免费
            //     1: '商品金额',
            //     2: '面议',
            //     3: '免费',
            //   }
            // },
          ],
          tableData: [],
        },
      }
    },
    // 创建完成
    created() {
      // console.log(this.goodsInfo);
      this.showObject = this.goodsInfo;
    },
    // import引入的组件需要注入到对象中才能使用
    components: {
      tableTotal
    },
    // 方法集合
    methods: {}
  }
</script>

<style lang="scss" scoped>
  .info_box {
    max-height: 600px;
    overflow-y: auto;
  }

  .imgInfo {
    width: 100px;
  }
</style>
